import * as types from './constants';
import { filter, uniqBy } from 'lodash';

const initialState = {
  namePopup: false,
  data: {
    id: null,
    name: '',
    users: []
  },
  connectedRowByUuid: {},
  unsavedChanges: false
};

const actions = {
  [types.GROUP_FLOW_SET_INIT]: (state, { payload }) => {
    const data = {
      ...state,
      data: {
        ...state.data,
        id: payload.id ? payload.id : state.data.id,
        name: payload.name ? payload.name : state.data.name,
        users: payload.users ? payload.users : state.data.users
      }
    };

    return { ...data };
  },

  [types.GROUP_FLOW_SET_PROP]: (state, { payload }) => {
    const data = {
      ...state,
      data: {
        ...state.data,
        [payload.prop]: payload.value
      },
      unsavedChanges: !payload.disableUnsavedChanges
    };

    return { ...data };
  },

  [types.GROUP_FLOW_SET_UNSAVED_CHANGES]: (state, { payload }) => {
    const data = {
      ...state,
      unsavedChanges: payload
    };

    return { ...data };
  },

  [types.GROUP_FLOW_SET_NAME_POPUP]: (state, { payload }) => {
    const data = {
      ...state,
      namePopup: payload
    };

    return { ...data };
  },

  [types.GROUP_FLOW_CLEAR]: () => {
    return { ...initialState };
  },

  [types.GROUP_FLOW_ADD_USER]: (state, { payload }) => {
    const uuid = payload?.creator?.uuid;

    const newMap = uuid
      ? { ...state.connectedRowByUuid, [uuid]: payload }
      : state.connectedRowByUuid;

    const data = {
      ...state,
      connectedRowByUuid: newMap,
      data: {
        ...state.data,
        users: uniqBy([payload.creator, ...state.data.users], 'uuid')
      },
      unsavedChanges: true
    };

    return { ...data };
  },

  [types.GROUP_FLOW_ADD_GROUP]: (state, { payload }) => {
    const data = {
      ...state,
      data: {
        ...state.data,
        users: uniqBy([...payload, ...state.data.users], 'uuid')
      },
      unsavedChanges: true
    };

    return { ...data };
  },

  [types.GROUP_FLOW_REMOVE_USER]: (state, { payload }) => {
    const uuid = payload?.uuid;

    const data = {
      ...state,
      connectedRowByUuid: uuid
        ? (() => {
          const next = { ...state.connectedRowByUuid };
          delete next[uuid];
          return next;
        })()
        : state.connectedRowByUuid,
      data: {
        ...state.data,
        users: filter(state.data.users, x => x.uuid !== payload.uuid)
      },
      unsavedChanges: true
    };

    return { ...data };
  },

  [types.GROUP_FLOW_REMOVE_ALL_USERS]: state => {
    const data = {
      ...state,
      connectedRowByUuid: {},
      data: {
        ...state.data,
        users: []
      },
      unsavedChanges: true
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};